"use client";
import { useState } from "react";
import Mydata from "../data/about/page.json";
import Commitment from "../../../public/updated-home/about/commitment.webp";
import Image from "next/image";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <>
      {isReadMore ? text.slice(0, 203) : text}
      <div
        onClick={toggleReadMore}
        className="style-redmore"
        style={{
          color: "#D5AF34",
          fontSize: "17px",
          display: "inline-block",
          marginLeft: "5px",
        }}
      >
        {isReadMore ? "Read More " : "Show less"}
      </div>
    </>
  );
};

function home() {
  const data = Mydata[1];
  return (
    <div style={{ background: "rgba(213, 175, 52, 0.1)" }}>
      <div className=" mx-auto px-6 pt-10 max-w-7xl pt-10 pb-10  grid grid-cols-5  lg:gap-10">
        <div className=" col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-3 ">
          <h2 className="text-3xl secondary font-bold ">
            Our Commitment to
            <span className="text-[#D5AF34]"> Excellence</span> <br />
          </h2>
          <p className="relative display mt-6 mb-3 updatedparapremu">
            {data.des0}
          </p>
          <p
            dangerouslySetInnerHTML={{ __html: data.des1 }}
            className="updatedparapremu pt-6"
          ></p>

          <div className="display-desktop mb-3 pt-3 ">
            <ReadMore>{data.des2}</ReadMore>
          </div>
        </div>
        <div className="auto col-span-12 sm:col-span-12 md:col-span-12  lg:col-span-2 ">
          <Image
            src={Commitment}
            width={900}
            alt="Commitment to Excellence"
            title="Commitment to Excellence"
          />
        </div>
      </div>
    </div>
  );
}

export default home;
